import store from '@/store/index.js'
// 包路径
const package_NdefRecord = 'android.nfc.NdefRecord';
const package_NdefMessage = 'android.nfc.NdefMessage';
const package_TECH_DISCOVERED = 'android.nfc.action.TECH_DISCOVERED';
const package_Intent = 'android.content.Intent';
const package_Activity = 'android.app.Activity';
const package_PendingIntent = 'android.app.PendingIntent';
const package_IntentFilter = 'android.content.IntentFilter';
const package_NfcAdapter = 'android.nfc.NfcAdapter';
const package_Ndef = 'android.nfc.tech.Ndef';
const package_NdefFormatable = 'android.nfc.tech.NdefFormatable';
const package_Parcelable = 'android.os.Parcelable';
const package_String = 'java.lang.String';

let NfcAdapter;
let NdefRecord;
let NdefMessage;
let Uri;
let noNFC = false;
let techListsArray = [
  ['android.nfc.tech.IsoDep'],
  ['android.nfc.tech.NfcA'],
  ['android.nfc.tech.NfcB'],
  ['android.nfc.tech.NfcF'],
  ['android.nfc.tech.Nfcf'],
  ['android.nfc.tech.NfcV'],
  ['android.net.Uri'],
  ['android.nfc.tech.NdefFormatable'],
  ['android.nfc.tech.MifareClassi'],
  ['android.nfc.tech.MifareUltralight']
];
// 要写入的数据
let text = 'https://baidu.com';
let readResult = '';
let success = ''
let id = ''
let chipUid = ''
let multipleURL = ""
let isNFCInitialized = false;


export default {
  writeMode: false,
  multipleURL : "",
  listenNFCStatus: function () {
    if (typeof plus === 'undefined') {
      console.log('不在 UniApp 环境中，跳过 NFC 初始化');
      return;
    }


    if (isNFCInitialized) {
      console.log('NFC 已经初始化，无需重复执行');
      return;
    }

    let that = this;
    try {
      let main = plus.android.runtimeMainActivity();
      let Intent = plus.android.importClass('android.content.Intent');
      let Activity = plus.android.importClass('android.app.Activity');
      let PendingIntent = plus.android.importClass('android.app.PendingIntent');
      let IntentFilter = plus.android.importClass('android.content.IntentFilter');
      Uri = plus.android.importClass('android.net.Uri');
      NfcAdapter = plus.android.importClass('android.nfc.NfcAdapter');
      let nfcAdapter = NfcAdapter.getDefaultAdapter(main);

      if (nfcAdapter == null) {
        alert('设备不支持NFC！');
        // uni.showToast({
        //   title: '设备不支持NFC！',
        //   icon: 'none'
        // })
        noNFC = true;
        return;
      }

      if (!nfcAdapter.isEnabled()) {
        // uni.showToast({
        //   title: '请在系统设置中先启用NFC功能！',
        //   icon: 'none'
        // });
        alert('请在系统设置中先启用NFC功能！');
        noNFC = true;
        return;
      } else {
        noNFC = false;
      }

      let intent = new Intent(main, main.getClass());
      intent.addFlags(Intent.FLAG_ACTIVITY_SINGLE_TOP);
      let pendingIntent = PendingIntent.getActivity(main, 0, intent, 0);
      let ndef = new IntentFilter("android.nfc.action.TECH_DISCOVERED");
      ndef.addDataType("*/*");
      let intentFiltersArray = [ndef];

      document.addEventListener('newintent', function () {
        console.log('处理NFC监听消息');
        // 监听 NFC
        setTimeout(() => that.nfcRunning(), 100);
      });
      document.addEventListener('pause', function (e) {
        console.log('暂停监听...');
        if (nfcAdapter) {
          //关闭前台调度系统
          //恢复默认状态
          nfcAdapter.disableForegroundDispatch(main);
        }
      });
      document.addEventListener('resume', function (e) {
        console.log('恢复监听...');
        if (nfcAdapter) {
          //开启前台调度系统
          nfcAdapter.enableForegroundDispatch(main, pendingIntent, intentFiltersArray, techListsArray);
        }
      });
      nfcAdapter.enableForegroundDispatch(main, pendingIntent, intentFiltersArray, techListsArray);
      this.enableReadData()
      isNFCInitialized = true;
    } catch (e) {
      console.error(e);
    }
  },
  random32bit() {
    let u = new Uint32Array(1);
    window.crypto.getRandomValues(u);
    let str = u[0].toString(16).toUpperCase();
    return '00000000'.slice(str.length) + str;
  },
  nfcRunning: function () {
    NdefRecord = plus.android.importClass("android.nfc.NdefRecord");
    NdefMessage = plus.android.importClass("android.nfc.NdefMessage");
    let main = plus.android.runtimeMainActivity();
    let intent = main.getIntent();
    let that = this;
    let bytesId = intent.getByteArrayExtra(NfcAdapter.EXTRA_ID);
    chipUid = that.byteArrayToHexString(bytesId);

    store.commit('setLastChipUid', chipUid)
    console.log('setLastChipUid:', chipUid);
    id = chipUid

    if (package_TECH_DISCOVERED == intent.getAction()) {

      /*
      if (store.getters.isProcessing === true) {
        console.log('---------之前的读写任务未处理完成,跳过本次处理')
        return;
      }*/

      if (store.getters.writeMode) {
        store.commit('SET_PROCESSING', true);
        that.write(intent);
        store.commit('SET_WRITE_MODE', false);
      } else if (store.getters.readMode) {
        store.commit('SET_PROCESSING', true);
        that.read(intent, chipUid);

        store.commit('SET_READ_MODE', false);
      } else {
        if (store.getters.multipleWrite) {
          this.showAlertAndContinue("写入失败,请重新写入", 3000)
          store.commit('SET_WRITE_MODE', true);
          store.commit('SET_PROCESSING', false);
          store.commit('SET_READ_MODE', false);
          that.writeData(multipleURL);
        } else {
          toast("现在是读取模式,请再试一次")
          store.commit('SET_WRITE_MODE', false);
          store.commit('SET_PROCESSING', false);
          store.commit('SET_READ_MODE', true);
        }
      }
    }
  },

  NFCStr2ab(text) {
    const prefixMap = {
      'http://www.': 0x01,
      'https://www.': 0x02,
      'http://': 0x03,
      'https://': 0x04,
      'mailto:': 0x05,
      'tel:': 0x06,
      'sms:': 0x07,
    };

    const bytes = [];

    // 判断是否包含协议
    if (text.includes(':')) {
      // 检查协议头并添加前缀字节
      let prefixByte = 0x00; // 默认无前缀
      for (const [prefix, code] of Object.entries(prefixMap)) {
        if (text.startsWith(prefix)) {
          prefixByte = code;
          text = text.slice(prefix.length); // 去掉协议头部分
          break;
        }
      }

      // 添加协议头字节
      bytes.push(prefixByte);
    }

    // 转换剩余内容为 UTF-8 编码
    for (let i = 0; i < text.length; i++) {
      bytes.push(text.charCodeAt(i));
    }

    return new Uint8Array(bytes).buffer;
  },

// 恢复状态的函数
  resetState(success) {
    if (store.getters.multipleWrite) {
      if (!success) {
        this.showAlertAndContinue("写入失败,请重新写入", 3000);
      }
      store.commit('SET_WRITE_MODE', true);
      store.commit('SET_PROCESSING', false);
      store.commit('SET_READ_MODE', false);
      if (!success) {
        this.writeData(multipleURL);
      }
    } else {
      if (!success) {
        toast('写入失败');
      }
      store.commit('SET_WRITE_MODE', false);
      store.commit('SET_PROCESSING', false);
      store.getters.readMode = !success;
    }
  },

  decodeString(encodedString) {
    // 将编码字符串拆分为一个字符数组
    const chars = encodedString.split('');
    // 遍历字符数组，每两个字符插入 %
    for (let i = 1; i < chars.length; i += 2) {
      chars.splice(i, 0, '%');
    }
    return  decodeURIComponent(chars.join(''));
  },

  /**
   * 处理文本，替换域名并附加
   * @param {string} text
   * @returns {string}
   */
  processText(text) {
    let processedText = text.replace('www.eforall.cn', 'eforall.cn');
    const randomCode = Math.floor(Math.random() * 1000000); // 生成范围为 [0, 999999]

    if (!processedText.includes("chipCode=")) {
      processedText += processedText.includes("?") ? `&chipCode=${randomCode}` : `?chipCode=${randomCode}`;
    }

    console.log("准备写入的 text=", processedText);
    return processedText;
  },

  /**
   * 解析URI并提取相关参数
   * @param {string} text
   * @returns {object|null}
   */
  parseUri(text) {
    const uriToWrite = Uri.parse(text);
    if (uriToWrite.host !== 'eforall.cn') {
      // 可选：提示用户域名不正确
      // toast('域名必须是包含 eforall.cn！');
      // return null;
    }

    const pathToWrite = uriToWrite.getPath();
    let linkName = "产品:";
    let idToWrite = uriToWrite.getQueryParameter("id");

    if (idToWrite === null) {
      linkName = "展架:";
      idToWrite = uriToWrite.getQueryParameter("shelfId");
    }
    if (idToWrite === null) {
      linkName = "资源:";
      idToWrite = uriToWrite.getQueryParameter("resourceId");
    }

    const nameToWrite = uriToWrite.getQueryParameter("name") || '';

    return { uriToWrite, pathToWrite, linkName, idToWrite, nameToWrite };
  },
  /**
   * 检测芯片现有数据
   * @param {object} intent
   * @param {object} uriData
   * @returns {object|null}
   */
  getExistingData(intent, uriData) {
    const rawMessages = intent.getParcelableArrayExtra("android.nfc.extra.NDEF_MESSAGES");
    if (rawMessages && rawMessages.length > 0) {
      console.log('检测到非空白芯片，开始读取数据...');
      const result = this.checkExistingRecords(rawMessages, uriData.pathToWrite, uriData.idToWrite);
      if (result.isMatch) {
        return result;
      }
    } else {
      console.log('检测到空白芯片，将进行格式化...');
    }
    return null;
  },

  /**
   * 确认是否覆盖现有数据
   * @param {object} existingData
   * @param {object} uriData
   * @returns {boolean}
   */
  confirmOverwrite(existingData, uriData) {
    const { linkName, idToWrite, nameToWrite } = uriData;
    let originMsg = '';
    const newMsg = `ID: ${idToWrite} ${nameToWrite}`;

    if (existingData.productName !== null) {
      originMsg = `${linkName}${existingData.productName}`;
    } else {
      originMsg = `记录ID:${existingData.originId}`;
    }

    // 创建自定义弹窗而不是使用原生confirm
    return this.showCustomConfirm(`芯片已写入${originMsg}。是否用 ${newMsg} 覆盖？`);
  },

  /**
   * 显示自定义确认弹窗
   * @param {string} message 
   * @returns {Promise<boolean>}
   */
  showCustomConfirm(message) {
    return new Promise((resolve) => {
      // 创建遮罩层
      const overlay = document.createElement('div');
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 10000;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding-bottom: 60px;
      `;

      // 创建弹窗容器
      const dialog = document.createElement('div');
      dialog.style.cssText = `
        background: white;
        border-radius: 20px 20px 20px 20px;
        padding: 40px 30px 30px 30px;
        margin: 0 20px;
        max-width: 600px;
        width: calc(100% - 40px);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
      `;

      // 创建消息文本
      const messageEl = document.createElement('div');
      messageEl.textContent = message;
      messageEl.style.cssText = `
        font-size: 32px;
        line-height: 1.5;
        text-align: center;
        color: #333;
        margin-bottom: 50px;
        word-break: break-all;
      `;

      // 创建按钮容器
      const buttonContainer = document.createElement('div');
      buttonContainer.style.cssText = `
        display: flex;
        flex-direction: column;
        gap: 20px;
      `;

      // 创建确认按钮
      const confirmBtn = document.createElement('button');
      confirmBtn.textContent = '确认覆盖';
      confirmBtn.style.cssText = `
        background: #50cc73;
        color: white;
        border: none;
        border-radius: 12px;
        padding: 20px;
        font-size: 32px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s;
        touch-action: manipulation;
      `;

      // 创建取消按钮
      const cancelBtn = document.createElement('button');
      cancelBtn.textContent = '取消';
      cancelBtn.style.cssText = `
        background: #f5f5f5;
        color: #666;
        border: none;
        border-radius: 12px;
        padding: 20px;
        font-size: 32px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s;
        touch-action: manipulation;
      `;

      // 按钮点击效果
      confirmBtn.addEventListener('touchstart', () => {
        confirmBtn.style.backgroundColor = '#45b366';
      });
      confirmBtn.addEventListener('touchend', () => {
        confirmBtn.style.backgroundColor = '#50cc73';
      });

      cancelBtn.addEventListener('touchstart', () => {
        cancelBtn.style.backgroundColor = '#e8e8e8';
      });
      cancelBtn.addEventListener('touchend', () => {
        cancelBtn.style.backgroundColor = '#f5f5f5';
      });

      // 事件处理
      const handleConfirm = () => {
        document.body.removeChild(overlay);
        resolve(true);
      };

      const handleCancel = () => {
        document.body.removeChild(overlay);
        console.log("用户选择不覆盖，操作终止。");
        resolve(false);
      };

      // 绑定事件
      confirmBtn.addEventListener('click', handleConfirm);
      cancelBtn.addEventListener('click', handleCancel);
      
      // 点击遮罩层关闭（相当于取消）
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          handleCancel();
        }
      });

      // 组装DOM
      buttonContainer.appendChild(confirmBtn);
      buttonContainer.appendChild(cancelBtn);
      dialog.appendChild(messageEl);
      dialog.appendChild(buttonContainer);
      overlay.appendChild(dialog);
      document.body.appendChild(overlay);
    });
  },

  /**
   * 构造NDEF消息
   * @param {object} uriToWrite
   * @returns {object}
   */
  createNdefMessage(uriToWrite) {
    const NdefRecord = plus.android.importClass('android.nfc.NdefRecord');
    const NdefMessage = plus.android.importClass('android.nfc.NdefMessage');

    const urlRecord = NdefRecord.createUri(uriToWrite);
    const ndefMessage = new NdefMessage([urlRecord]);

    console.log("准备写入消息:", JSON.stringify(ndefMessage));
    return ndefMessage;
  },

  /**
   * 获取NFC标签
   * @param {object} intent
   * @returns {object|null}
   */
  getTag(intent) {
    const tag = intent.getParcelableExtra(NfcAdapter.EXTRA_TAG);
    if (!tag) {
      toast('无法获取 NFC 标签');
      return null;
    }
    return tag;
  },

  /**
   * 写入NDEF消息到标签
   * @param {object} tag
   * @param {object} ndefMessage
   * @returns {boolean}
   */
  writeTag(tag, ndefMessage) {
    const Ndef = plus.android.importClass('android.nfc.tech.Ndef');
    const ndef = Ndef.get(tag);

    if (ndef != null) {
      return this.writeNdefMessage(ndef, ndefMessage);
    } else {
      return this.formatAndWrite(tag, ndefMessage);
    }
  },

  /**
   * 处理写入成功后的逻辑
   * @param {object} intent
   * @param {string} processedText
   */
  handleWriteSuccess(intent, processedText) {
    const bytesId = intent.getByteArrayExtra(NfcAdapter.EXTRA_ID);
    const chipUid = this.byteArrayToHexString(bytesId);

    if (!chipUid) {
      toast('无法获取chipUid');
      this.resetState(false);
      return;
    }

    const link = `${processedText}&chipUid=${chipUid}&variation=${this.random32bit()}`;
    console.log('=============写入link ', link);

    // 成功提示并记录写入信息
    if (store.getters.multipleWrite) {
      console.log("写入数据成功,批量写入模式静默不提示");
      store.commit('nfcWriteLog', `芯片:${chipUid}写入成功`);
    } else {
      toast('写入数据成功！');
    }

    store.commit('setNfcWriteTxt', link);
    this.resetState(true);
  },

// 检查现有记录是否匹配
  async write(intent) {
    let that = this;
    try {
      if (!text) {
        toast('待写入内容不能为空！');
        this.resetState(false);
        return;
      }
      // 处理文本
      const processedText = this.processText(text);

      // 解析URI
      const uriData = this.parseUri(processedText);
      if (!uriData) {
        // 可选：提示用户域名不正确
        // toast('域名必须是包含 eforall.cn！');
        // this.resetState(false);
        // return;
      }

      // 检测现有芯片数据
      const existingData = this.getExistingData(intent, uriData);
      if (existingData) {
        const shouldOverwrite = await this.confirmOverwrite(existingData, uriData);
        if (!shouldOverwrite) {
          this.resetState(false);
          return;
        }
      }

      // 构造NDEF消息
      const ndefMessage = this.createNdefMessage(uriData.uriToWrite);
// 获取并写入标签
      const tag = this.getTag(intent);
      if (!tag) {
        toast('无法获取 NFC 标签');
        this.resetState(false);
        return;
      }

      const success = this.writeTag(tag, ndefMessage);
      if (success) {
        this.handleWriteSuccess(intent, processedText);
      } else {
        this.resetState(false);
      }
    } catch (error) {
      console.error('写入过程中出现错误:', error);
      this.resetState(false);
    }
  },

// 检查现有记录
  checkExistingRecords(rawMessages, pathToWrite, idToWrite) {
    let isMatch = false;
    let productName = null;
    let originId = null;

    rawMessages.forEach((msg) => {
      const records = msg.getRecords();
      for (const [recordIndex, record] of records.entries()) {
        try {
          const payloadArrayBuffer = record.getPayload();
          const decodedPayloadPath = this.decodePayloadToPath(payloadArrayBuffer);
          console.log(`读取到的路径: ${decodedPayloadPath}`);

          // 使用 URI 解析提取 id 和 name 参数
          const existingUri = Uri.parse(decodedPayloadPath);
          const existingName = existingUri.getQueryParameter("name"); // 获取 name 参数作为产品名

          let existingId = existingUri.getQueryParameter("id");
          if (existingName === null) {
            existingId = existingUri.getQueryParameter("shelfId");
          }
          if (existingName === null) {
            existingId = existingUri.getQueryParameter("resourceId");
          }
          isMatch = true;
          originId = existingId
          productName = existingName || productName; // 如果有 name 参数，设置为产品名
          break;
          // 比较路径和 id
          //if (pathToWrite === existingPath && idToWrite === existingId) {

          //}
        } catch (error) {
          console.error(`Error processing record[${recordIndex}]:`, error);
        }
      }
    });

    return { isMatch, originId,  productName };
  },



// 写入 NDEF 消息
  writeNdefMessage(ndef, ndefMessage) {
    let success = false
    try {
      const size = ndefMessage.toByteArray().length;

      ndef.connect();
      if (!ndef.isWritable()) {
        toast('Tag 不允许写入！');
        return;
      }

      if (ndef.getMaxSize() < size) {
        toast('文件大小超出容量！');
        return;
      }
      ndef.writeNdefMessage(ndefMessage);
      success = true
    } catch (e) {
      console.error('写入失败:', e);
    } finally {
      ndef.close();
    }
    return success
  },

  formatAndWrite(tag, ndefMessage) {
    let success = false;
    try {
      const NdefFormatable = plus.android.importClass('android.nfc.tech.NdefFormatable');
      const format = NdefFormatable.get(tag);

      if (format) {
        try {
          format.connect();
          format.format(ndefMessage);
          toast('格式化标签并成功写入消息');
          success = true;
        } catch (e) {
          console.error('格式化标签失败:', e);
          toast('格式化标签失败，请检查标签是否支持写入');
        } finally {
          format.close();
        }
      } else {
        toast('标签不支持 NDEF 格式');
      }
    } catch (e) {
      console.error('操作失败:', e);
      toast('操作失败，无法格式化标签');
    }
    return success;
  },

  ab2str(buffer) {
    const uint8Array = new Uint8Array(buffer);
    let result = '';
    for (let i = 0; i < uint8Array.length; i++) {
      result += String.fromCharCode(uint8Array[i]);
    }
    return result;
  },
  decodePayloadToPath(payload) {
    const prefixMap = {
      0x00: '', // 自定义协议，无前缀
      0x01: 'http://www.',
      0x02: 'https://www.',
      0x03: 'http://',
      0x04: 'https://',
    };

    const uint8Array = new Uint8Array(payload);
    const prefixByte = uint8Array[0]; // 第一个字节表示前缀
    const prefix = prefixMap[prefixByte] || '';

    const uriContent = this.ab2str(uint8Array.slice(1)); // 去掉前缀字节后的内容
    const fullURI = prefix + uriContent;

    if (prefixByte === 0x00) {
      // 无前缀，去掉协议
      const [schemeAndPath, queryString] = fullURI.split('?');
      const path = schemeAndPath.includes('://')
        ? schemeAndPath.split('://')[1]
        : schemeAndPath;
      return queryString ? `${path}?${queryString}` : path;
    } else if (prefixByte >= 0x01 && prefixByte <= 0x04) {
      // 有域名的情况，去掉协议和域名
      const urlObject = new URL(fullURI);
      return urlObject.pathname + urlObject.search; // 返回路径和查询参数
    } else {
      throw new Error(`Unsupported prefix byte: ${prefixByte}`);
    }
  },


  read(intent, chipUid) {
    try {
      console.log(`----开始读取芯片${chipUid}消息`)
      let that = this;
      let rawMessages = intent.getParcelableArrayExtra("android.nfc.extra.NDEF_MESSAGES");
      console.log("-----------------rawMessages", JSON.stringify(rawMessages));
      if (rawMessages != null && rawMessages.length > 0) {
        rawMessages.forEach(msg => {

          let records = msg.getRecords();
          console.log("--------------records ", JSON.stringify(records));
          for (const [recordIndex, record] of records.entries()) {
            try {
              const payloadArrayBuffer = record.getPayload();
              const decodedPayloadPath = this.decodePayloadToPath(payloadArrayBuffer);
              console.log(`--------decodedPayloadPath[${recordIndex}]:`, decodedPayloadPath);

              if (decodedPayloadPath.length > 0) {
                const separator = decodedPayloadPath.includes('?') ? '&' : '?';
                let toURL = `${decodedPayloadPath}${separator}chipUid=${chipUid}&variation=${this.random32bit()}`;
                console.log(`--------read URL 处理完成[${recordIndex}]:`, toURL);
                store.commit('setNfcReadTxt', toURL);
                break; // 找到有效数据后退出循环
              }
            } catch (recordError) {
              console.error(`Error processing record[${recordIndex}]:`, recordError);
            }
          }
        })
      } else {
        toast('未读取到有效数据,只有用小掌写入数据后的芯片才能读取相关信息哦!');
        setTimeout(() => {
          this.enableReadData()
            .then((result) => {
              // 在这里处理成功的情况
              console.log('Data read successfully:', result);
              // 例如，可以根据读取的数据执行某些逻辑
            })
            .catch((error) => {
              // 在这里处理失败的情况
              console.error('Failed to read data:', error);
              // 提示用户出错的信息
              this.$toast('读取数据失败');
            });
        }, 1500);

      }
    } catch (e) {
      //TODO handle the exception
    }
  },
  byteArrayToHexString: function (inarray) { // converts byte arrays to string
    let i, j, inn;
    let hex = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];
    let out = "";

    for (j = 0; j < inarray.length; ++j) {
      inn = inarray[j] & 0xff;
      i = (inn >>> 4) & 0x0f;
      out += hex[i];
      i = inn & 0x0f;
      out += hex[i];
    }
    return out;
  },
  writeData: function (url) {
    if (noNFC) {
      toast('请检查设备是否支持并开启 NFC 功能！');
      return;
    }
    // 监听事件，触发条件
    store.commit('SET_WRITE_MODE', true);


    //toast('请将NFC标签靠近,手机感应到NFC芯片后点确定！');
    text = url;
    return id
  },

  multipleWriteData: function (url) {
    multipleURL = url;
    store.commit('SET_MULTIPLE_WRITE', true);
    this.writeData(url)
  },

  //新增的方法 写入并跳转
  writeDataAndJump: function (url) {

    if (noNFC) {
      toast('请检查设备是否支持并开启 NFC 功能！');
      return;
    }
    // 监听事件，触发条件
    store.commit('SET_WRITE_MODE', true);
    toast('请将NFC标签靠近！');
    text = url;
    //返回写入成功
    while (resStatus === 'ok') {
      return 'ok';
    }

  },
  readData: function () {
    if (typeof plus === 'undefined') {
      console.log('不在 UniApp 环境中，跳过');
      return;
    }

    if (noNFC) {
      toast('请检查设备是否支持并开启 NFC 功能！');
      return;
    }
    store.commit('SET_READ_MODE', true);
    console.log("readData 已设置readyRead为true...开始下一步读取....")
  },

  forceReadDataMode: function () {
    store.commit('SET_PROCESSING', false);
    store.commit('SET_MULTIPLE_WRITE', false);
    store.commit('SET_WRITE_MODE', false);
    store.commit('SET_READ_MODE', true);
  },

  showAlertAndContinue: function (message, delay = 3000) {
  const alertDiv = document.createElement('div');
  alertDiv.innerText = message;
  alertDiv.style.position = 'fixed';
  alertDiv.style.top = '30%';
  alertDiv.style.left = '50%';
  alertDiv.style.transform = 'translate(-50%, -50%)';
  alertDiv.style.backgroundColor = 'white';
  alertDiv.style.padding = '20px';
  alertDiv.style.boxShadow = '0px 0px 10px rgba(0,0,0,0.5)';
    alertDiv.style.zIndex = '9999';


    document.body.appendChild(alertDiv);

  setTimeout(() => {
    document.body.removeChild(alertDiv);
    console.log('提示框消失，继续执行代码...');
  }, delay);
},

  enableReadData: async function () {
    let that = this;

    if (store.getters.multipleWrite === true) {
      //toast("请将芯片从NFC读写处移开。")
      console.log('写入成功')
      let nextWrite = false;
      this.showAlertAndContinue("写入成功,在提示关闭后您可继续写入下一芯片或者离开", 2000)
      nextWrite = true
      store.commit('SET_PROCESSING', false);
      that.writeData(multipleURL);


      if (nextWrite) {
        return;
      }
    }

    store.commit('SET_PROCESSING', false);

    if (typeof plus === 'undefined') {
      console.log('不在 UniApp 环境中，跳过');
      return;
    }

    if (noNFC) {
      toast('请检查设备是否支持并开启 NFC 功能！');
      return;
    }
    // 监听事件，触发条件
    store.commit('SET_READ_MODE', true);
    console.log("----enableReadData 恢复 NFC 处理读取的消息")
  },

  // 输入文本改变
  inputChanage: function (res) {
    console.log("正在编辑写入数据...", res)
    text = res
  },
  setReadDataFalse: function () {
    // 轮询条件
    store.commit('SET_READ_MODE', false);
  },
  setReadDataTrue: function () {
    store.commit('SET_READ_MODE', true);
  }
}

function toast(content) {
  alert(content);
}



// WEBPACK FOOTER //
// ./src/utils/nfc.js